const entityTypeId = 131;

const schema = {
  "contactId": "",
  "sourceId": "",
  "sourceDescription": "",
  "parentId159": "",
  "title": "contactFio",
  "ufCrm22Phone": "phone",
  "ufCrm22PositionAtWork": "positionAtWork",
};

export {
  entityTypeId,
  schema,
};